import {
    CircularProgress as MuiCircularProgress,
    CircularProgressProps as MuiCircularProgressProps,
} from '@mui/material';
import React from 'react';

export type CircularProgressSize = 'small' | 'medium' | 'large';

export type CircularProgressProps = Omit<
    MuiCircularProgressProps,
    | 'size'
    | 'color'
    | 'thickness'
    | 'variant'
    | 'value'
    | 'min'
    | 'max'
    | 'disableShrink'
    | 'enableTrackSlot'
    | 'classes'
> & { size?: CircularProgressSize };

const SIZE_PX: Record<CircularProgressSize, number> = { small: 16, medium: 20, large: 40 };

/** A loading spinner. For one centred in its area, use `CenteredSpinner`. */
export const CircularProgress = React.forwardRef(function CircularProgress(
    { size = 'large', ...props }: CircularProgressProps,
    ref: React.ForwardedRef<HTMLSpanElement>,
): JSX.Element {
    return <MuiCircularProgress ref={ref} {...props} size={SIZE_PX[size]} />;
});
